import GraphQLClient from '../../core/adapter/graphQLClient';
import OrderProduct from '../../entity/orderProduct';
import Session from '../../entity/session';
import getProductOrder from './query/getProductOrder';

class ProductOrderRepository {
  private graphqlClient: GraphQLClient;

  constructor({ graphqlClient }: { graphqlClient: GraphQLClient }) {
    this.graphqlClient = graphqlClient;
  }

  public getProductOrder(
    session: Session,
    {
      orderId,
      id,
      manageId,
    } : {
      orderId: string,
      id?: string,
      manageId?: string,
    }): Promise<OrderProduct> {
    return this.graphqlClient
      .query(session, getProductOrder, { variables: { orderId, id, manageId } })
      .then(({ data }: { data: any }) => OrderProduct.fromJson(data['productOrderByOrder']));
  }
}

export default ProductOrderRepository;
